import React from "react";
import {
    getFieldTypeLabel,
    hideModal,
    showModalNoOutsideClick,
    getBoolSelectYN,
    buildRow,
    getNameFromID,
    getLabel,
    handleCloseModal,
    wellSlots
} from "../../util/FormatUtil";
import { CustomFieldsModal } from "./CustomFieldsModal";
import InBetweenOverlay from "../InBetweenOverlay";
import Overlay from "../Overlay";
import CustomFieldsAPI from "../../network/CustomFieldsAPI";
import { sweetalert } from "../../App";
import {BiMoveVertical} from "react-icons/bi";
import {isEmptyObject} from "jquery";
import Select from "react-select";
import SimpleTable from "../tables/SimpleTable";
import { AiOutlineClose } from "react-icons/ai";
import {isBlank, isOnlyWhitespace} from "../../util/ValidationUtil";


//PlatingDirection => 0 is vertical, 1 is horizontal



const backgroundColors = [
    {label: 'Select...', value: null},
    {label: 'Red', value: 'bg-danger'},
    {label: 'Blue', value: 'bg-primary'},
    {label: 'Grey', value: 'bg-secondary'},
    {label: 'Green', value: 'bg-success'},
    {label: 'Yellow', value: 'bg-warning'},
    {label: 'Light Blue', value: 'bg-info'}
]

interface WellPlateSettingsState{
    selectedService?
    showInBetween
    showLoading
}
interface WellPlateSettingsProps{
    selectedService?
    handleInBetween?
    submit
}
export class WellPlateSettingsModal extends React.Component<WellPlateSettingsProps, WellPlateSettingsState>{
    public dragItemRef;
    public dragOverItemRef;
    public static ID = "wellPlateSettings";
    
    constructor(props) {
        super(props);
        
        this.state = {
          showLoading: false,
          showInBetween: false,
        }
    }

    componentWillReceiveProps(nextProps:any, nextContext: any) {
         if(!isEmptyObject(nextProps.selectedService)){
            let selectedService = nextProps.selectedService;
            this.setState({
                selectedService: selectedService
            });
        } else {
            this.setState({
                selectedService: null
            });
        }
    }

    removeRow(val){
        sweetalert
        .fire({
            html: `<p style="margin-top: 1rem;"> Are you sure you want to remove this control row? `,
            showCloseButton: false,
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: "Remove Control Row",
            denyButtonText: "Cancel",
        })
      .then((result) => {
        if (result.isConfirmed) {
            //filter out removed well slot
            let selectedServiceCopy = JSON.parse(JSON.stringify(this.state.selectedService))
            let filteredSS = selectedServiceCopy.WellplateSettings.filter(f => f.ID !== val.ID)

            if(filteredSS.length < 1){
                filteredSS = null
            }

            this.setState((prevState)=>({
                selectedService: {
                    ...prevState.selectedService,
                    WellplateSettings: filteredSS
                }
            }))

        } else {
          return;
        }
      });
    }

    addRow(){
        //add blank obj to WellplateSettings array
        let selectedServiceCopy = JSON.parse(JSON.stringify(this.state.selectedService))
        selectedServiceCopy.WellplateSettings.push({ID: selectedServiceCopy.WellplateSettings.length + 1, WellSlot: null, BlockedText: '', BackgroundClass: null})

        this.setState({selectedService: selectedServiceCopy})
    }

   
    render(){

        // console.log('WellPlateSettingsModal props', this.props)
        // console.log('WellPlateSettingsModal state', this.state)
        
        return(
            <>
            <Overlay show_loading={this.state.showLoading} zIndex={100005}/>
            <InBetweenOverlay showInBetween={this.state.showInBetween} zIndex={100004} />
            <div className="modal fade form_modal " id={WellPlateSettingsModal.ID} tabIndex={-1} style={{zIndex: 100003}} role="dialog"
                 aria-labelledby="result_modal_label"
                 aria-hidden="true">
                <div className="modal-dialog modal-lg modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                              <h5 className="modal-title" id="result_modal_label">Well Plate Settings Management</h5>
                              <button  style={{outline: 'none'}} type="button" className="close" data-dismiss="modal" aria-label="Close" 
                              onClick={() => {
                                this.props.handleInBetween()
                              }}>
                                  <span aria-hidden="true">&times;</span>
                              </button>                                                             
                        </div>
                        <div className="modal-body m-3 ">
                            <div className="px-3">
                            {buildRow("Plating Direction",
                                <Select
                                    isSearchable={true}
                                    placeholder={"Please Select..."}
                                    noOptionsMessage={() => "No option"}
                                    value={this.state.selectedService ? getLabel(this.state.selectedService.PlatingDirection, [{label: 'Vertical', value: 0}, {label: 'Horizontal', value: 1}]) : null}
                                    onChange={(e) => this.setState((prevState)=>({
                                        selectedService: {
                                            ...prevState.selectedService,
                                            PlatingDirection: e.value
                                        }
                                    }))}
                                    className={"state_select"}
                                    options={[{label: 'Vertical', value: 0}, {label: 'Horizontal', value: 1}]}
                                />
                            , 'Direction the Well Plate will be populated'
                            )}
                            </div>
                            <div style={{border: '1px solid lightgrey'}}>
                            {this.state.selectedService && this.state.selectedService.WellplateSettings && this.state.selectedService.WellplateSettings.length > 0 ?
                                <SimpleTable
                                    columns={[
                                        { label: "Control Well Slot", key: "WellSlot",
                                            rawFormat: (val) => {
                                                return (
                                                    <Select
                                                        isSearchable={true}
                                                        placeholder={"Select..."}
                                                        noOptionsMessage={() => "No option"}
                                                        value={{label: wellSlots.find(f => f.value === val.WellSlot).label, value: wellSlots.find(f => f.value === val.WellSlot).value}}
                                                        onChange={(e) => {
                                                            const id = val.ID;
                                                            let selectedServiceCopy = JSON.parse(JSON.stringify(this.state.selectedService))
                                                            let newSettings = selectedServiceCopy.WellplateSettings.map(item => {
                                                                if(item.ID === id){
                                                                    return {
                                                                        ...item,
                                                                        WellSlot: e.value
                                                                    };
                                                                }
                                                                return item;
                                                            })
                                                            this.setState((prevState)=>({
                                                                selectedService: {
                                                                    ...prevState.selectedService,
                                                                    WellplateSettings: newSettings
                                                                }
                                                            }))
                                                        }}
                                                        className={"state_select"}
                                                        options={wellSlots}
                                                    />
                                                )
                                            } 
                                        },
                                        { label: "Control Text ", key: "BlockedText",
                                            rawFormat: (val) => {
                                                return (
                                                    <input className={"form-control"}
                                                        maxLength={10}
                                                        autoComplete={"off"}
                                                        type={"search"}
                                                        name={"BlockedText"}
                                                        onChange={(e)=>{
                                                            const id = val.ID;
                                                            let selectedServiceCopy = JSON.parse(JSON.stringify(this.state.selectedService))
                                                            let newBlockedText = selectedServiceCopy.WellplateSettings.map(item => {
                                                                if(item.ID === id){
                                                                    return {
                                                                        ...item,
                                                                        BlockedText: e.target.value
                                                                    };
                                                                }
                                                                return item;
                                                            })
                                                            this.setState((prevState)=>({
                                                                selectedService: {
                                                                    ...prevState.selectedService,
                                                                    WellplateSettings: newBlockedText
                                                                }
                                                            }))
                                                        }}
                                                        value={val.BlockedText}
                                                    />
                                                )
                                            } 
                                        },
                                        { label: "Control Background Color", key: "BackgroundClass",
                                            rawFormat: (val) => {
                                                return (
                                                    <Select
                                                        isSearchable={true}
                                                        placeholder={"Select..."}
                                                        noOptionsMessage={() => "No option"}
                                                        value={{label: backgroundColors.find(f => f.value === val.BackgroundClass).label, value: backgroundColors.find(f => f.value === val.BackgroundClass).value}}
                                                        onChange={(e) => {
                                                            const id = val.ID;
                                                            let selectedServiceCopy = JSON.parse(JSON.stringify(this.state.selectedService))
                                                            let newBackgroundClass = selectedServiceCopy.WellplateSettings.map(item => {
                                                                if(item.ID === id){
                                                                    return {
                                                                        ...item,
                                                                        BackgroundClass: e.value
                                                                    };
                                                                }
                                                                return item;
                                                            })
                                                            this.setState((prevState)=>({
                                                                selectedService: {
                                                                    ...prevState.selectedService,
                                                                    WellplateSettings: newBackgroundClass
                                                                }
                                                            }))
                                                        }}
                                                        className={"state_select"}
                                                        options={backgroundColors}
                                                    />
                                                )
                                            } 
                                        },
                                        {label:"", key:"",
                                            rawFormat: (val) => (
                                                <div className="text-center">
                                                    <AiOutlineClose color={"red"} size={30} onClick={(e) => this.removeRow(val)} />
                                                </div>
                                            )
                                        }
                                        
                                        
                                    ]}
                                    table_data={this.state.selectedService.WellplateSettings} table_style="tableFixHead"
                                />
                                :
                                <div className="text-center p-3">No Control Rows to display</div>
                            }
                            </div>
                            
                        </div>
                        <div className="modal-footer mx-3">
                            <button type="button" className={"btn btn-success mr-auto"} onClick={() => this.addRow()} > Add Control Row </button>
                            <button type="button" className={"btn btn-primary"} onClick={() => {
                                //add validations
                                if(this.state.selectedService.PlatingDirection === null || this.state.selectedService.PlatingDirection === 'undefined'){
                                    return sweetalert.fire("", "Plating Direction cannot be empty", "error")
                                }
                            
                                //loop through this.state.selectedService.WellplateSettings and make sure all fields have value
                                if(this.state.selectedService.WellplateSettings && this.state.selectedService.WellplateSettings.length > 0){
                                    let invalid = false;
                                    for (let i = 0; i < this.state.selectedService.WellplateSettings.length; i++) {
                                        const td = this.state.selectedService.WellplateSettings[i];
                                        if(
                                            !td.WellSlot || !td.BlockedText || td.BlockedText.trim().length < 1 || td.BlockedText.trim().length > 10 || !td.BackgroundClass){
                                            invalid = true
                                            break
                                        }
                                    }
                                
                                    if(invalid){
                                        this.setState({showLoading: false})
                                        return sweetalert.fire("", "All fields in table must be complete and Control Text must be less than 10 characters.", "error")
                                    }
                                
                                    //check for duplicate Well Slots
                                    if(this.state.selectedService.WellplateSettings.length > 1){
                                      let wellslots = [];
                                      this.state.selectedService.WellplateSettings.map(td => {
                                        wellslots.push(td.WellSlot)
                                      })
                                      let duplicates = wellslots.filter((item, index) => wellslots.indexOf(item) !== index)
                                      if(duplicates.length > 0){
                                        this.setState({showLoading: false})
                                        return sweetalert.fire({icon: 'error', title: '', text: "Duplicate Well Slots detected"});
                                      }
                                    }
                                }
                                hideModal(WellPlateSettingsModal.ID)
                                this.props.handleInBetween()
                                this.props.submit(this.state.selectedService)
                            }}> Submit </button>
                        </div>
                    </div>
                </div>
            </div>
            </>
        )
    }
}